export const calcQtdSabores = (itens: any): number => {
  if (!itens) return 0;

  let qtdTemp = 1 / Math.min(...itens.map((produto: any) => +produto.quantity));

  if (1 - qtdTemp > 0.002) {
    let i = 2;
    while ((qtdTemp * i) % 1 !== 0) {
      i += 1;
    }
    qtdTemp *= i;
  }

  return qtdTemp;
};
